const feVersion = {
    ciBuildNumberTemplate: '20261104.6',
    ciBranchNameTemplate: 'dev',
    ciCommitIdTemplate: '20a84abb2b3149681e24acc0959c16e5a16bc480',
    buildNumber: 440,
    version: '3.8.0',
    databaseVersion: 30800,
    shortCommitId: function () {
        if (this.ciCommitIdTemplate.length > 7 && !this.ciCommitIdTemplate.startsWith('#')) {
            return this.ciCommitIdTemplate.substring(0, 7);
        }
        return this.ciCommitIdTemplate;
    }
};

export default feVersion;
